import { Skeleton, Box, Alert } from '@mui/material';
import { ApolloError } from '@apollo/client';

import { MetricPanel, MetricPanelProps } from '@occc/ui-design-system';
import { ScanDataSftpCredentialsOverviewFragment } from '@occc/graphql';

import { SUBMISSION_GROUPS_OVERVIEW_SKELETON_HEIGHT } from './submission-groups-overview.constants';

type SubmissionGroupsOverviewProps = {
  loading: boolean;
  error: ApolloError | undefined;
  data?: ScanDataSftpCredentialsOverviewFragment;
};

export const SubmissionGroupsOverview = ({
  data,
  loading,
  error,
}: SubmissionGroupsOverviewProps) => {
  if (loading) {
    return (
      <Skeleton
        variant='rectangular'
        width='100%'
        height={SUBMISSION_GROUPS_OVERVIEW_SKELETON_HEIGHT}
      />
    );
  }

  if (error || !data) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: SUBMISSION_GROUPS_OVERVIEW_SKELETON_HEIGHT,
        }}
      >
        <Alert severity='error'>Failed to load Group Overview. Please try again later.</Alert>
      </Box>
    );
  }

  const { totalAltria, totalRJR, totalMSA } = data;

  const metrics: MetricPanelProps['metrics'] = [
    {
      label: 'Altria Submission Groups',
      value: totalAltria,
      isTrendHidden: true,
    },
    {
      label: 'RJR Submission Groups',
      value: totalRJR,
      isTrendHidden: true,
    },
    {
      label: 'MSA Submission Groups',
      value: totalMSA,
      isTrendHidden: true,
    },
  ];

  return (
    <Box mb={1}>
      <MetricPanel title='Group Overview' metrics={metrics} />
    </Box>
  );
};
